/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './YourInformation.module.scss'
import { masterNumberAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'

const MasterNumber = ({ t, validateMasterNumber, masterNumberValid, masterNumberError, setIsError }) => {
  const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const masterNumber = useSelector((state) => state.yourInformation.masterNumber)

  const handleMasterNumber = (e) => {
    try {
      let masterNumberElem = e.currentTarget.value
      if (RegExp(/^[a-zA-Z0-9 ]*$/i).test(masterNumberElem)) {
        dispatch(masterNumberAction(masterNumberElem))
      }
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const onBlurMasterNumber = (e) => {
    try {
      SetIsFocussed(false)
      let element = e.currentTarget.value
      if (RegExp(/^[a-zA-Z0-9 ]{10,14}$/i).test(element) && RegExp(/^[a-zA-Z]*$/i).test(element[0])) {
        let lastName = '',
          datePosition = 0
        for (let i = 0; i < 5; i++) {
          if (isNaN(element[i])) {
            datePosition++
          }
          if (element[i] === ' ') {
            lastName = lastName + ' '
          } else {
            lastName = isNaN(element[i]) ? lastName + element[i] : lastName + ' '
          }
        }
        lastName = lastName + element.substring(datePosition).trim()
        dispatch(masterNumberAction(lastName.trim()))
        validateMasterNumber(lastName.trim())
      } else {
        dispatch(masterNumberAction(element.trim()))
        validateMasterNumber(element.trim())
      }
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  return (
    <div className={styles['fields_margin']}>
      <div
        className={
          masterNumberValid === true
            ? masterNumber !== '' && 'form-group has-success'
            : masterNumberValid === false && 'form-group ns-form-group-message-error'
        }
      >
        <label className="control-label" htmlFor="MasterNumber">
          {t('your_information.master_number')}
        </label>
        <div className="help-field">{t('your_information.your_master_number_can_be')}</div>
        {masterNumberValid === false && (
          <div className="ns-form-error-container has-error error-msg-align">
            <i className={['fa fa-exclamation-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
            <div className={isFocussed ? 'help-block-focused' : 'help-block'}>
              <span>{t(masterNumberError)}</span>
            </div>
          </div>
        )}
        <input
          type="text"
          id="MasterNumber"
          className="form-control"
          value={masterNumber}
          onChange={handleMasterNumber}
          //onBlur={onBlurMasterNumber}
          onFocus={() => SetIsFocussed(true)}
          autoComplete="off"
          maxLength="14"
        />
        {masterNumberValid === true && masterNumber !== '' && (
          <i className={['fa fa-check-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
        )}
      </div>
    </div>
  )
}

export default withTranslation('common')(MasterNumber)
